import React, { PureComponent } from 'react'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import { environment } from '../../../environment'
import mixpanelTrackingProvider from '../../../services/mixpanelTrackingProvider'
import mixpanel from 'mixpanel-browser'
import activityTrackingService from '../../../services/activityTrackingService'
import Layer from '../Layer'
import Icon from '../Icon'

class Footer extends PureComponent {
  componentDidMount () {
    mixpanel.init(environment.MIXPANEL_TOKEN, {
      persistence: 'localStorage',
      api_host: environment.MIXPANEL_HOST,
      debug: environment.MIXPANEL_DEBUG === 'true',
      batch_requests: false,
      opt_out_tracking_by_default: true,
      loaded: () => {
        mixpanelTrackingProvider.ready()
        activityTrackingService.registerTrackingProvider(mixpanelTrackingProvider)
      }
    })
  }

  onPrivacySettingsClick = () => {
    if (window.hasOwnProperty('CCM')) {
      window.CCM.openWidget()
    }
    return false
  }
  state = {
    showContactUsLayer: false
  }

  render () {
    const { t } = this.props
    return (
      <>
        {this.state.showContactUsLayer &&
          <Layer type="center" size="small" id={'contact-us-layer'}
                 show={true}
                 onHideClick={() => this.setState({ showContactUsLayer: false })}>
            <div>
              <h2>{t('CONTACT_US')}</h2>
              <div>
                Please do not hesitate to contact the GIATA Hotel Content Team for assistance at any time.
                Outside our general office hours between Monday and Friday from 7 a.m. and 7 p.m CET,
                please leave your details for us to respond to your enquiry as soon as possible.
              </div>
              <div className="list">
                <div className="entry">
                  <div className="entry-image">
                    <a href="mailto:hotels@giata.com">
                      <Icon type={'envelope'}/>
                    </a>
                  </div>
                  <div className="entry-value">
                    <a href="mailto:hotels@giata.com">hotels@giata.com</a></div>
                </div>
                <div className="entry">
                  <div className="entry-image">
                    <a href="tel:+493042026555">
                      <Icon type={'phone'}/>
                    </a>
                  </div>
                  <div className="entry-value"><a href="tel:+493042026555">+49 30 420 265 55</a></div>
                </div>
              </div>
            </div>
          </Layer>
        }
        <footer className="mygiata_footer">
          <div className="mygiata_footer_top">
            <nav className="mygiata_footer_navi">
              <ul>
                <li><a href={t('URL_LEGAL_NOTICE')} rel="noreferrer"
                       target="_blank">{t('LEGAL_NOTICE')}</a></li>
                <li><a href={t('URL_PRIVACY_POLICY')} rel="noreferrer"
                       target="_blank">{t('PRIVACY_POLICY')}</a></li>
                <li>
                  <span onClick={this.onPrivacySettingsClick} className={'Link'}>{t('PRIVACY_SETTINGS')}</span>
                </li>
                <li>
                  <span
                    className={'Link'}
                    onClick={() => this.setState({ showContactUsLayer: true })}
                  >
                    {t('CONTACT_US')}
                  </span>
                </li>
              </ul>
            </nav>
            <div className="mygiata_copyright">&copy; GIATA GmbH - {t('ALL_RIGHTS_RESERVED')}</div>
          </div>
        </footer>
      </>
    )
  }
}

export default withTranslation()(Footer)
